import React from 'react';
import HostList from '../../components/host/HostList';

const HostListPage = () => {
  return (
    <div>
      <HostList />
    </div>
  );
};

export default HostListPage;